import { apiRequest } from '../../shared/api/client';

/**
 * The current tenant (GET /api/v1/tenant — any authenticated user). Used for
 * the shell greeting ("Welcome {name} — {Org}") and later for tenant settings.
 * Mirrors Invetrak.Api.Endpoints.TenantEndpoints.TenantDto (camelCase).
 */
export interface TenantDto {
  tenantId: string;
  tenantSlug: string;
  displayName: string;
  status: string;
  tier: string;
  defaultLocale: string;
  defaultTimeZone: string;
  defaultCurrencyCode: string;
}

const COOKIE_INIT: RequestInit = { credentials: 'include' };

export async function getTenant(signal?: AbortSignal): Promise<TenantDto> {
  const { data } = await apiRequest<TenantDto>('/v1/tenant', {
    method: 'GET',
    signal,
    ...COOKIE_INIT,
  });
  return data;
}
